import { UserWorkLog } from '../../../types/apiDomain';
import { EmployeeCalendarProject } from '../../../types/reportTypes';

const getProjectsFromUserWorkLogs = (workLogs: UserWorkLog[] | undefined) => {
    const projects: EmployeeCalendarProject[] = [];

    workLogs?.forEach((workLog) => {
        const { project, issueId, issueUrl, issueName } = workLog;

        let foundProject = projects.find((projectObj) => projectObj.id === project);

        if (!foundProject) {
            projects.push({
                id: project,
                issues: [],
                amount: 0
            });
            foundProject = projects.find((projectObj) => projectObj.id === project);
        }

        if (foundProject) {
            const foundIssue = foundProject.issues.find((issue) => issue.id === issueId);

            const plusAmount = workLog.minutes / 60;
            foundProject.amount += plusAmount;

            if (foundIssue) {
                foundIssue.worklogs.push(workLog);

                foundIssue.amount += plusAmount;
            } else {
                foundProject.issues.push({
                    id: issueId,
                    worklogs: [workLog],
                    url: issueUrl ?? null,
                    desc: issueName ?? issueId,
                    amount: plusAmount
                });
            }
        }
    });

    return projects;
};

export default getProjectsFromUserWorkLogs;
